// extracted by mini-css-extract-plugin
export default {"sold-price-tit":"Rank_sold-price-tit__1BtYy","sold-tit":"Rank_sold-tit__McEuv"};